/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-8c8a3203.js';
import { _ as _slicedToArray } from '../_chunks/dep-605e961c.js';
import React, { useState, useRef, useEffect, useCallback } from 'react';
import classNames from 'classnames';
import useConfig from '../hooks/useConfig.js';
import useMutationObservable from '../_util/useMutationObserver.js';
import '../_chunks/dep-f66447d3.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-1d5f47c2.js';
import '../_chunks/dep-8670d51c.js';
import '../_chunks/dep-df9f8f04.js';
import '../_chunks/dep-9d326786.js';
import '../_chunks/dep-3542b5f1.js';
import '../_chunks/dep-79aca757.js';
import '../_chunks/dep-c7d784af.js';
import '../_chunks/dep-2055661d.js';
import '../_chunks/dep-73c3cd54.js';
import '../_chunks/dep-ced835e2.js';
import '../_chunks/dep-1e76a561.js';
import '../_chunks/dep-6b33e1e9.js';
import '../_chunks/dep-dae4a585.js';
import '../_chunks/dep-9e05eaf2.js';
import '../_chunks/dep-0d617aaa.js';
import '../_chunks/dep-030d278c.js';
import '../_chunks/dep-868937ef.js';
import '../_chunks/dep-6f5c07a7.js';
import '../_chunks/dep-a79a1775.js';
import '../_chunks/dep-7b744c82.js';
import '../_chunks/dep-0b20126b.js';
import '../_chunks/dep-2b7035c1.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-4fce6f2f.js';
import '../_common/js/global-config/default-config.js';
import '../_chunks/dep-ac257584.js';
import '../_chunks/dep-37e82645.js';
import '../_chunks/dep-a0293295.js';

var TabBar = function TabBar(props) {
  var _classNames;
  var tabPosition = props.tabPosition,
    activeId = props.activeId,
    containerRef = props.containerRef;
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    barStyle = _useState2[0],
    setBarStyle = _useState2[1];
  var tabsClassPrefix = "".concat(classPrefix, "-tabs");
  var currentActiveIdRef = useRef(activeId);
  useEffect(function () {
    currentActiveIdRef.current = activeId;
  }, [activeId]);
  var computeStyle = useCallback(function () {
    var isHorizontal = ["bottom", "top"].includes(tabPosition);
    var transformPosition = isHorizontal ? "translateX" : "translateY";
    var itemProp = isHorizontal ? "width" : "height";
    var barBorderProp = isHorizontal ? "width" : "height";
    var offset = 0;
    if (containerRef.current) {
      var _containerRef$current, _containerRef$current2;
      var itemsRef = (_containerRef$current = (_containerRef$current2 = containerRef.current).querySelectorAll) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.call(_containerRef$current2, ".".concat(tabsClassPrefix, "__nav-item"));
      if (itemsRef.length - 1 >= currentActiveIdRef.current) {
        itemsRef.forEach(function (item, itemIndex) {
          if (itemIndex < currentActiveIdRef.current) {
            offset += Number(getComputedStyle(item)[itemProp].replace("px", ""));
          }
        });
        var computedItem = itemsRef[currentActiveIdRef.current];
        if (!computedItem) {
          setBarStyle(_defineProperty({
            transform: "".concat(transformPosition, "(", 0, "px)")
          }, barBorderProp, 0));
          return;
        }
        var itemPropValue = getComputedStyle(computedItem)[itemProp];
        setBarStyle(_defineProperty({
          transform: "".concat(transformPosition, "(").concat(offset, "px)")
        }, barBorderProp, itemPropValue || 0));
      }
    }
  }, [currentActiveIdRef, containerRef, tabPosition, tabsClassPrefix]);
  useEffect(function () {
    if (containerRef.current) {
      setTimeout(function () {
        return computeStyle();
      });
    }
  }, [tabPosition, activeId, containerRef.current]);
  var handleMutationObserver = useCallback(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === "characterData") {
        computeStyle();
      }
    });
  }, [computeStyle]);
  useMutationObservable(containerRef.current, handleMutationObserver);
  return /* @__PURE__ */React.createElement("div", {
    className: classNames((_classNames = {}, _defineProperty(_classNames, "".concat(tabsClassPrefix, "__bar"), true), _defineProperty(_classNames, "".concat(classPrefix, "-is-").concat(tabPosition), true), _classNames)),
    style: barStyle
  });
};
TabBar.displayName = "TabBar";

export { TabBar as default };
//# sourceMappingURL=TabBar.js.map
